import { Card } from '@mui/material';

import React from 'react';

import {
  List,
  Datagrid,
  TextField,
  ArrayField,
  SingleFieldList,
  SelectInput,
  SelectField,
  usePermissions,
  ArrayInput,
} from 'react-admin';

import { boldDataGridStyle } from '../../constants/style/datagridStyles';

import NoResults from '../layout/NoResults';
import Pagination from '../layout/Pagination';
import LinkField from '../layout/LinkField';

import ColoredScoreField from '../../customFields/ColoredScoreField';
import ChipStringField from '../../customFields/ChipStringField';
import { productTypesChoices } from '../../constants/productTypes';
import ReferenceEntityField from '../../customFields/ReferenceEntityField';
import EntityDisplayNameField from '../../customFields/EntityDisplayNameField';
import { ReferenceManyDisplayField } from '../../customFields/EditReferenceManyField';
import SearchField from '../../customFields/SearchField';
import EntityFilter from '../filters/EntityFilter';
import entityTypes from '../../constants/entityTypes';
import actions, { Actions } from '../../constants/actions';
import hasAccess from '../../utilities/hasAccess';
import GroupFilter from '../utils/GroupFilter';

export const ProductListBody = ({ children }: {children?: React.ReactNode}) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid bulkActionButtons={false} sx={boldDataGridStyle} empty={<NoResults variant="h6" />}>
      {hasAccess(permissions, actions.PRODUCT_GET) ? (
        <LinkField sortable={false} source="id" label="ID" />
      ) : (
        <TextField sortable={false} source="id" label="ID" />
      )}
      <ArrayField sortable={false} source="customIds" label="Custom IDs">
        <SingleFieldList linkType={false}>
          <ChipStringField />
        </SingleFieldList>
      </ArrayField>
      {hasAccess(permissions, actions.GROUP_GET) && (
        <ReferenceManyDisplayField
          label="Groups"
          reference="groups"
          source="groups"
        />
      )}
      <TextField sortable={false} source="productNumber" />
      <TextField sortable={false} source="productDescription" />
      <SelectField sortable={false} source="productType" choices={productTypesChoices} />
      <ArrayField sortable={false} source="parties" label="Parties">
        <SingleFieldList linkType={false}>
          <ReferenceEntityField source="">
            <EntityDisplayNameField chip />
          </ReferenceEntityField>
        </SingleFieldList>
      </ArrayField>
      <ColoredScoreField sortable source="riskScore" />
      {children}
    </Datagrid>
  );
};

// TODO: Do the permissions for all entity filters
export const ProductFilters = [
  <SearchField source="search" label="Search" alwaysOn />,
  <ArrayInput source="groups" label="Groups">
    <GroupFilter />
  </ArrayInput>,
  <EntityFilter
    label="Parties"
    source="parties.id"
    allowedTypes={[entityTypes.INDIVIDUAL, entityTypes.BUSINESS, entityTypes.ACCOUNT]}
  />,
  <SelectInput source="productType" choices={productTypesChoices} />,
];

const ProductList = () => (
  <List
    resource="products"
    filters={ProductFilters}
    sort={{ field: 'createdAt', order: 'DESC' }}
    empty={false}
    pagination={<Pagination disableEmptyText />}
    exporter={false}
    perPage={50}
  >
    <Card sx={{ margin: 0 }} variant="outlined">
      <ProductListBody />
    </Card>
  </List>
);

export default ProductList;
